// Core
import React, { useState } from 'react';
import { Box, Button, Link, Flex, Text, Divider, Grid, Image, useColorMode, useColorModeValue, useBreakpointValue } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import glow from 'assets/img/main-prizes.png';
import phone from 'assets/img/main-screen.png';
import phoneWhite from 'assets/img/main-screen-white.png';
import bannerImage from 'assets/img/banner.png';
import bannerMobileImage from 'assets/img/banner-mobile.jpg';
import cars from 'assets/img/cars.png';
import house from 'assets/img/house.png';
import merch from 'assets/img/merch.png';
import allPrizes from 'assets/img/all-prizes.png';
import featuredImage1 from 'assets/img/featured-image-1.png';
import featuredImage2 from 'assets/img/featured-image-2.png';
import featuredImage3 from 'assets/img/featured-image-3.png';
import featuredImage4 from 'assets/img/featured-image-4.png';
import animatedHome from 'assets/img/login/home.png';
import animatedCar1 from 'assets/img/login/car1.png';
import animatedCar2 from 'assets/img/login/car2.png';
import animatedCrystal from 'assets/img/login/crystal.png';
import animatedTicket from 'assets/img/login/ticket.png';
import animatedBox from 'assets/img/login/box.png';
import videoHero from 'assets/video/hero.mp4';

// Components
import { StarsIcon, MapIcon, ArrowDiscountIcon } from 'components/Icons/Icons';
import Card from 'components/Card/Card';
import TypeCard from './components/TypeCard';
import Giveaways from './components/Giveaways';
import GiveawayWinners from './components/GiveawayWinners';
import Membership from 'components/Membership/Membership';
import Privileges from './components/Privileges';
import RewardsClub from './components/RewardsClub';
import Reviews from 'components/Sliders/Reviews';
import HomeSubHeaderSlider from 'components/Sliders/HomeSubHeader';
import BuiltDifferentSlider from 'components/Sliders/BuiltDifferent';
import Li from 'components/Lists/List';

const Home = ({ userData }) => {
  const bgDivider = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const bgDividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const cardTopLine = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 56.18%, #FFF 68.16%, #38A9E1 82.69%, rgba(56, 169, 225, 0.00) 100%)';
  const textColor = useColorModeValue('#0E1633', 'white'); 
  const textColorViewAllButton = useColorModeValue('#262D47', '#9FABCB');
  const textColorViewAllArrow = useColorModeValue('white', '#0E1633');
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const [membershipData, setMembershipData] = useState([]);

  const responsiveBannerImage = useBreakpointValue({
      base: bannerMobileImage, 
      sm: bannerImage
  });

  const EXTERNAL_URL_PETROL = "https://lmctgiveaway.com/petrol-loyalty-join";
  const EXTERNAL_URL_MEMBERSHIP = "https://lmctgiveaway.com/loyalty-membership";

  return (
    <>
      <Box 
        position="relative" 
        p={{ base: '0 0 28px 0 ', sm: '0 80px 32px 80px', lg: '0 0 100px 0' }}
        w={{ base: '100%' }}
        left={{ base: '0' }}
        float="unset"
        alignItems="center"
        justifyContent="center"
        m={{ base: '-140px auto 0px auto', md: '0px auto 0 auto' }}
        maxW="867px">
        <Box
          position="absolute"
          top={{base: '-60px', md: '-273px'}}
          left="50%"
          transform="translateX(-50%)"
          width="100vw"
          height={{base: 'calc(100% + 60px)', md: 'calc(100% + 274px)'}}
          zIndex={-1}
          overflow="hidden"
          _before={{
            width: '100%',
            height: '100%',
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            background: isDark 
              ? 'linear-gradient(0deg, rgba(0, 7, 28, 0.70) 0%, rgba(0, 7, 28, 1) 100%)'
              : 'linear-gradient(0deg, rgba(224, 234, 255, 0.80) 0%, rgba(224, 234, 255, 1) 100%)'
          }}
        >
          <video
            src={videoHero}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>

        { isDark && <Box className="abstract-grad animation-scale-grad" mt={{base: '170px', md: '50px'}} />}
        { /*isDark ?  <Lines className="abstract-lines" /> :  <LinesWhite className="abstract-lines" />*/}
        { isDark && <Box className="abstract-grad animation-scale-grad" left="60%" transform="scale(1.7)" bottom="30%" />}
        <Image src={ isDark ? phone : phoneWhite } alt='phone' 
          right={{sm: '100px', md: '100px', lg: '-52px'}}
          top={{base: '50px', sm: '-20px', md: '-95px', lg: '-142px'}}
          maxW={{base: '320px', sm: '260px', md: '435px', lg: '545px'}}
          left={{base: '43%', sm: 'unset'}}
          transform={{base: 'translate(-50%, 0px)', sm: 'unset'}}
          w="100%" position="absolute" zIndex="-1"/>
        <Box 
          className="abstract-grad" 
          left={{base: '20%',sm: '40%', md: '60%'}}
          transform="scale(1.1)" 
          bottom={{base: '60%', sm: '60%', md: '30%'}} />
        <Image src={glow} alt='glow'
          right={{sm: '-10px', md: '-10px', lg: '-48px'}}
          top={{base: '220px', sm: '90px', md: '141px'}}
          maxW={{base: '290px', sm: '230px', md: '410px', lg: '513px'}}
          left={{base: '57%', sm: 'unset'}}
          transform={{base: 'translate(-50%, 0px)', sm: 'unset'}}
          w={{base: '460px', sm: '100%'}} position="absolute" 
          zIndex={{base: '1', sm: '-1'}}/>
        <Box 
          display={{base: 'block', md: 'none'}}
          bg={ isDark ? '#00071C' : '#dfe9fd'} zIndex="-1" filter="blur(60px)" opacity="0.5" borderRadius="100%" w={{base: '100%', sm: '70%', md: 'none'}} h="290px" position="absolute" />
        
        <Text as="h1" mt="183px">
          <Text as="span" variant="header" pl="12px"
            fontSize={{base: '36px', md: '64px', lg: '72px'}}
            >AUSTRALIA`S</Text><br />
          <Text as="span" variant="header-gradient" mt="-12px" w="fit-content" 
            lineHeight={{base: '64px', lg: '97px'}}
            fontSize={{base: '72px', md: '96px', lg: '128px'}}
            pr={{base: '8px'}}
            >
            BEST<Divider borderWidth="0" bottom={{base: '8px', sm: '12px', lg: '20px'}} h="2px" bg={ isDark ? bgDivider : bgDividerWhite} position="absolute" /></Text><br />
          <Flex alignItems="center" 
            gap={{base: '8px' ,sm: '24px'}} 
            pl={{base: '8px' ,sm: '26px'}} 
            mt={{base: '16px', md: '18px', lg: '26px'}}>
            <StarsIcon fontSize={{base: '24px', md: '42px'}} />
            <Box
               as="span"
               borderRadius={{base: '8px', sm: '16px'}}
               p={{base: '3px 2px 3px 10px', sm: '3px 18px 3px 24px'}}
               w={{sm: 'min-content', lg: 'unset'}}
               textAlign={{sm: 'center', lg: 'unset'}}
               background="white">
              <Text 
                variant="header-gradient" 
                pr={{base: '8px'}}
                fontSize={{base: '36px', md: '64px', lg: '72px'}}>Petrol Loyalty</Text>
            </Box>
          </Flex>
          <Text as="span" variant="header" 
            lineHeight={{base: '54px', lg: '81px'}}
            fontSize={{base: '28px', md: '36px', lg: '48px'}}
            >Members Pay less</Text>
        </Text>

        <Text as="h2" maxW={{base: '100%', sm: '46%'}} color={textColor} mt={{base: '290px', sm: '4px'}}>
        	Join LMCT Fuel Loyalty and get more value from every fill-up. Track your fuel purchases, earn points, and unlock exclusive bonuses and fuel discounts.
        </Text>

        <a href={EXTERNAL_URL_PETROL} alt="Sign Up">
        <Button variant={ isDark ? 'button-lg-g' : 'button-lg' } maxW={{base: '100%', sm: '280px'}} mt={{base: '24px', sm: '38px'}}>Join Now</Button>
        </a>

        <Box h={{base: '0px', md: '140px'}} />
      </Box>

      <HomeSubHeaderSlider />

      <Box textAlign="center" mb={{base: '24px', sm: '36px'}} mt={{base: '56px', sm: '56px', md: '80px'}}>
        <Flex mt="-6px" gap={{base: '12px', sm: '21px'}} pl="26px" m="16px 0 14px 0" w="100%" alignItems="center" justifyContent="center">
          <StarsIcon fontSize={{base: '24px', md: '45px'}} />
          <Box>
            <Text variant="header-gradient" fontSize={{base: '32px', sm: '44px', md: '48px'}}>
              More Than Just Fuel
            </Text>
          </Box>
          <StarsIcon fontSize={{base: '24px', md: '45px'}} />
        </Flex>
        <Box
           m="0 auto"
           borderRadius="16px"
           p="6px 12px 6px 16px"
           w="fit-content"
           background="white">
          <Text variant="header-gradient" fontSize={{base: '32px', sm: '44px', md: '48px'}} pr="4px">
            The more you fill, the more you earn
          </Text>
        </Box>
      </Box>

      <Grid templateColumns={{ sm: '1fr', md: '1fr 1fr 1fr' }} gap="24px" rowGap="60px" templateRows='1fr' 
        mt={{base: '80px', lg: '140px'}}>
        <TypeCard 
            src={merch} 
            title="SAVE" 
            description="Per litre. Every fill"
            maxW={{base: '226px', lg: '300px'}} 
            mt={{base: '-65px', lg: '-100px'}} 
        />
        <TypeCard 
            src={house} 
            title="EARN" 
            description="Coins, EXP & entries at the pump"
            maxW={{base: '226px', lg: '256px'}} 
            mt={{base: '-65px', lg: '-84px'}} 
        />
        <TypeCard 
            src={cars} 
            title="Merchandise" 
            description="Cars, cash & prizes. Every month"
            maxW={{base: '226px', lg: '256px'}} 
            mt={{base: '-65px', lg: '-84px'}} 
        />
      </Grid>

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} mt={{base: '40px', lg: '0px'}}
        fontStyle="normal">Built Different</Text>
      <BuiltDifferentSlider />

      <Box 
        boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.10)"
        position="relative" 
        overflow="hidden" borderRadius="16px" 
        m={{base: '50px 0px 60px 0px', md: '50px 0px 80px 0px'}}
        >
        <Image 
          objectFit="cover"
          src={responsiveBannerImage} 
          transform={{base: 'scale(1.04)', sm: 'scale(1.009)'}}
          alt="Banner" w="100%" 
          />
      </Box>

      <Membership 
        setMembershipData={setMembershipData} 
        linkPetrol={EXTERNAL_URL_PETROL}
        linkMembership={EXTERNAL_URL_MEMBERSHIP}
        />
    </>
  );
};

export default Home;